module.exports = __webpack_public_path__ + "static/media/prio1.3cd56841.jpg";